import { Routes } from '@angular/router';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { ExpenseComponent } from './expense.component';
import { AddEditExpenseComponent } from './add-edit-expense/add-edit-expense.component';
import { ViewExpenseComponent } from './view-expense/view-expense.component';
import { ExpenseApprovalComponent } from './expense-approval/expense-approval.component';
import { ExpensePostingComponent } from './expense-posting/expense-posting.component';
import { ExpenseApprovalWorkflowComponent } from './expense-approval-workflow/expense-approval-workflow.component';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { FinanceShellComponent } from '../shared/page-layout/finance-shell.component';

export const expenseRoutes: Routes = [
    {
        path: 'expense',
        component: FinanceShellComponent,
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: { enterpriseModules: ['ACCOUNTING', 'GENERAL_LEDGER', 'SHIPMENTS'], enterpriseFeatureLabel: 'Finance' },
        children: [
            {
                path: '',
                component: ExpenseComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.expense.records.view },
            },
            {
                path: 'add',
                component: AddEditExpenseComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.expense.records.create },
            },
            {
                path: 'edit/:id',
                component: AddEditExpenseComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.expense.records.edit },
            },
            {
                path: 'view/:id',
                component: ViewExpenseComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.expense.records.view },
            },
            {
                path: 'approvals',
                component: ExpenseApprovalComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.expense.approval.view },
            },
            {
                path: 'post',
                component: ExpensePostingComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.expense.posting.view },
            },
            {
                path: 'workflow-setup',
                component: ExpenseApprovalWorkflowComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.expense.approval.configure },
            },
        ],
    },
];
